module.exports = global["jQuery"] = require("-!D:\\WORKING\\public2\\zsm\\landing\\sinh-nhat-hai-tuoi\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");